if (!window.shopponiLocaleFetchPatched) {
  window.shopponiLocaleFetchPatched = true;
  const shopponiNativeFetch = window.fetch.bind(window);

  window.fetch = function (input, init) {
    let localizedInput = input;
    if (typeof input === 'string' && input === '/cart/update.js') {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      localizedInput = root + 'cart/update.js';
    }
    return shopponiNativeFetch(localizedInput, init);
  };
}

if (typeof FacetFiltersForm !== 'undefined') {
  const shopponiOriginalRenderProductCount = FacetFiltersForm.renderProductCount;

  FacetFiltersForm.renderProductCount = function (html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const sourceCount = parsedHTML.getElementById('ProductCount');
    const targetCount = document.getElementById('ProductCount');

    if (!sourceCount || !targetCount) {
      document.querySelectorAll('.product-count').forEach((container) => {
        container.classList.remove('loading');
      });
      document.querySelectorAll('.product-count .loading__spinner').forEach((spinner) => {
        spinner.classList.add('hidden');
      });
      return;
    }

    return shopponiOriginalRenderProductCount.call(this, html);
  };
}

(function shopponiHideEditionFacet() {
  const pageIsFilterable = document.body && (
    document.body.classList.contains('template-collection') ||
    document.body.classList.contains('template-search')
  );

  if (!pageIsFilterable) return;

  const editionLabels = new Set(['edizione', 'edition', 'édition', 'edicion', 'edición', 'ausgabe']);
  const normalize = (value) => (value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  const isEditionLabel = (value) => editionLabels.has(normalize(value));

  function hideFacetBlock(block) {
    if (!block || block.dataset.shopponiEditionHidden === 'true') return;
    block.dataset.shopponiEditionHidden = 'true';
    block.hidden = true;
    block.setAttribute('aria-hidden', 'true');
    block.style.display = 'none';
  }

  function hideEditionFacet(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('details, .facets__disclosure, .mobile-facets__details, .facets__item, .filter-item').forEach((block) => {
      const label = block.querySelector('summary, .facets__summary, .facets__heading, .filter-label, .title');
      if (label && isEditionLabel(label.textContent)) hideFacetBlock(block);
    });

    scope.querySelectorAll('input[name*="filter.v.option."], input[name*="filter.p.option."], input[name*="filter.v.m."], input[name*="filter.p.m."]').forEach((input) => {
      const name = normalize(input.getAttribute('name'));
      if (!name.includes('edizione') && !name.includes('edition')) return;
      const block = input.closest('details, .facets__disclosure, .mobile-facets__details, .facets__item, .filter-item');
      if (block) hideFacetBlock(block);
    });
  }

  function run() {
    hideEditionFacet(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) hideEditionFacet(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
